<ea-status-bar [$status]="$message()"
    [$statusType]="$statusType()"
    [$delay]="$delay()"
    (delayElapsed)="handleDelayElapsed()" />
